import React, { FC } from 'react';
import { IWizardProps } from 'types/wizard';
import Apply from '../Pages/Build/Apply';
import ArchTypePage from '../Pages/Build/ArchType';
import PrimaryMethods from '../Pages/Build/PrimaryMethods';
import SecondaryMethod from '../Pages/Build/SecondaryMethods';
import Suggestions from '../Pages/Build/Suggestions';
import { WIZARD_PAGES } from '../utils/consts';

const Build: FC<IWizardProps> = (props) => {
	const {
		state: { page, combinations }
	} = props;

	let ContentComp = null;
	switch (page) {
		case WIZARD_PAGES.archType:
			ContentComp = ArchTypePage;
			break;
		case WIZARD_PAGES.primaryMethods:
			ContentComp = PrimaryMethods;
			break;
		case WIZARD_PAGES.secondaryMethod:
			ContentComp = SecondaryMethod;
			break;
		case WIZARD_PAGES.suggestions:
			if (combinations.length === 1) {
				ContentComp = Apply;
			} else {
				ContentComp = Suggestions;
			}
			break;
		case WIZARD_PAGES.apply:
			ContentComp = Apply;
			break;
		default:
			ContentComp = ArchTypePage;
			break;
	}

	return <ContentComp {...props} />;
};

export default Build;
